<template>
  <b-form>
    Date: {{ form.date }}
    <b-form-group label="FX">
      <b-form-input
        @change="setValue('fx', $event)"
        :state="validateState('fx')"
        v-model.trim="$v.form.fx.$model"
        type="number"
      />
      <b-form-invalid-feedback id="input-description-live-feedback">
        This is a required field.
      </b-form-invalid-feedback>
    </b-form-group>

    <div class="text-right mt-2">
      <!-- delete button -->
      <b-button
        variant="danger"
        class="mr-2"
        @click="
          form.fx = 0;
          saveFXDate();
        "
      >
        Delete
      </b-button>
      <b-button
        :disabled="$v.form.$invalid || saveFxDate === 'fetching'"
        variant="primary"
        @click="saveFXDate()"
      >
        <b-spinner v-if="saveFxDate === 'fetching'" variant="white" small />
        <span v-else>{{ $t("submit") }}</span>
      </b-button>
    </div>
  </b-form>
</template>
<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import { POST_FX_DATE } from "./actions";
import { superAdminMixin } from "../../mixins";

export default {
  name: "FxForm",
  props: {
    date: {
      type: String,
      required: true,
    },
    fx: {
      type: String,
      required: false,
    },
    closeModal: {
      type: Function,
      required: false,
    },
  },
  mixins: [superAdminMixin],
  computed: {
    ...mapState({
      saveFxDate: (state) =>
        state.superAdminStore.componentStore.fxCalendar.status,
    }),
  },
  data() {
    return {
      form: {
        date: this.date,
        fx: this.fx,
      },
    };
  },
  validations: {
    form: {
      fx: {
        required,
      },
    },
  },

  methods: {
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form.fx = null;
      this.form.date = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    saveFXDate() {
      this.$store.dispatch(POST_FX_DATE, this.form).then(() => {
        this.resetForm();
        if (this.form.fx != 0) {
          this.toastMessage("Fx saved", "Success", "success");
        } else {
          this.toastMessage("Fx deleted", "Success", "success");
        }
        this.closeModal();
      });
    },
  },
};
</script>
